import { Menu, MenuItem, Typography, IconButton, Stack, Button } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledMenu = styled(Menu)(({ theme }) => ({
    "& .MuiPaper-root": {
        borderRadius: 4,
        marginTop: theme.spacing(1),
        minWidth: 180,
    },
}));

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
    "& .MuiTypography-root": {
        fontSize: 14,
    },
    "&:hover": {
        backgroundColor: theme.palette.action.hover,
        "& .MuiTypography-root": {
            color: theme.palette.primary.main,
        },
    },
}));
